RivalIQ.apps.Insights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.VideoListItem = views.ContentListItem.extend({
        template: '#contentVideoListItemTemplate'
    });

    views.LinkedInVideoListItem = views.ContentListItem.extend({
        template: '#linkedInVideoListItemTemplate',

        linkedinTemplateHelpers: function () {
            const me = this;

            const nativeId = me.model.get('native_id');

            return {
                videoIframeSrc: `https://www.linkedin.com/embed/feed/update/${nativeId}?compact=1`
            };
        }
    });
});
